import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarHoverRateSheet(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="RateSheet"?"":"RateSheet")} title="RateSheet" className={props.activeMenu == "RateSheet" ? "sidenav-collapsed-active pointer px-0 sidenavbar-text":"pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("ratesheet:ratesheet:view")?false:true}>
                <span className="mx-2 sidenavbar-text">Rate Sheet
                    <i className={showMenu=="RateSheet"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "RateSheet" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/ratesheet/slotratesheet")} title="SlotRateSheet" 
                className={props.activeSubMenu == "SlotRateSheet" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("ratesheet:slotratesheet:view")?false:true}>
                    Slot Rate Sheet
                </a>
            </ul>
            <ul className={showMenu == "RateSheet" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/ratesheet/slotagreement")} title="SlotAgreement" 
                className={props.activeSubMenu == "SlotAgreement" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("ratesheet:slotagreement:view")?false:true}>
                    Slot Agreement
                </a>
            </ul>
        </>
    );
}

export default SideNavBarHoverRateSheet;
